<div class="w-75">
  <h1 class="title">Sök nämnardata</h1>
  <p class="brodtext-medium-14">
    Nedan kan data sökas i Svebars databas. Här söker man ut antal positiva och negativa fynd för vald analys(er) <br>
    och/eller provtyp(er).
  </p>
  <app-search-form [searchType]="searchType"></app-search-form>
</div>
